import React from "react";
import {useDispatch} from "react-redux";
import {useFormik} from "formik";
import {FormElements} from "../../../shared/ui/forms/FormElements";
import {formStructureCatalog, validationSchemaValidity} from "../lpData";
import {Form} from "react-bootstrap";
import {CreateLpSubValidityAction} from "../../../../redux/lp/lpActions";
import {RowSaveCancel} from "../../../shared/ui/forms/RowSaveCancel";
import {getEndOfDay, getStartOfDay} from "../../../utils/dateUtils";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";


export function FormCreateLpSubValidity({closeForm}) {
  const {t} = useLanguageForShared()

  const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {},
        validationSchema: validationSchemaValidity(t),
        onSubmit: values => {
            const data = {
                beginValidity: getStartOfDay(values.beginValidity).toISOString(),
                endValidity: getEndOfDay(values.endValidity).toISOString()
            };
            dispatch(CreateLpSubValidityAction(t, data, closeForm))
        }
    });
  return (
      <Form onSubmit={formik.handleSubmit}>
          <FormElements structure={formStructureCatalog(t)} formik={formik}></FormElements>
          <RowSaveCancel closeForm={closeForm} />
      </Form>
  );
}
